<script>
    export let lead;
    export let text;
</script>
{#if lead !== null && text !== null}
    <div class="element columns">
        <div class="lead column is-one-quarter">
            <strong>{lead}:</strong>
        </div>
        <div class="text column">
            {text}
        </div>
    </div>
{/if}